import { PRICE_TYPES } from '@bytel/bytel-sales';

export interface ISim {
    gencode: string;
    isPrefered: boolean;
    isCompatibleTerminal: boolean;
    price: number;
    priceType: PRICE_TYPES;
    type: SIM_TYPES;
}

export interface ISimQuote {
    id: string;
    isCurrent: boolean;
    isCompatible: boolean;
    compatibleSims: ISim[];
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum SIM_TYPES {
    SIM = 'sim',
    ESIM = 'esim',
    QRESIM = 'qr_esim',
}
